import { render, staticRenderFns } from "./CardNumberOfPayments.vue?vue&type=template&id=13dd1e0f&"
import script from "./CardNumberOfPayments.vue?vue&type=script&lang=js&"
export * from "./CardNumberOfPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports